import { useAdminCompanyController_findOneById } from '@api-client/generated/AdminCompanyController/findOneById';

import useAccount from './useAccount';

export const isBackofficeTransactionsAccessAllowed = (
  allowedAdminIds: string[] | null | undefined,
  userId: string | undefined,
): boolean => {
  if (!allowedAdminIds?.length) {
    return true;
  }
  if (!userId) {
    return false;
  }
  return allowedAdminIds.includes(userId);
};

type UseBackofficeTransactionsAccessOptions = {
  companyId: string | undefined;
};

const useBackofficeTransactionsAccess = ({
  companyId,
}: UseBackofficeTransactionsAccessOptions) => {
  const { account } = useAccount();

  const {
    data: company,
    isPending,
    isError,
  } = useAdminCompanyController_findOneById({
    params: { id: companyId! },
    config: { enabled: !!companyId },
  });

  const resolved = !isPending && !isError;

  const canView = resolved
    ? isBackofficeTransactionsAccessAllowed(company?.backofficeTransactionsAllowedAdminIds, account?.id)
    : false;

  const isBlocked =
    (!isPending && isError) ||
    (!!company?.backofficeTransactionsAllowedAdminIds?.length &&
      !company.backofficeTransactionsAllowedAdminIds.includes(account?.id ?? ''));

  return { canView, isLoading: isPending, isBlocked, isError };
};

export default useBackofficeTransactionsAccess;
